var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('div',[_c('div',{staticClass:"text-center text-xs"},[_c('PhoneSVG'),_c('span',{staticClass:"underline"},[_vm._v(_vm._s(_vm.getPhoneNumber))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }